export default __webpack_public_path__ + "static/media/empty-filtered-projects-table.de3561ff.svg";